
import React from 'react'
import { compose } from 'redux'
import injectSheet from 'react-jss'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import _ from 'lodash'
import Collapse from './CollapseGroup'
import helpers from 'helpers'

// Actions
import * as merchantActions from '../actions/components/merchant'
import * as tableActions from '../actions/components/table'
import * as basketActions from '../actions/components/basket'

class TableList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loadingTableOrders: false,
      expandGroup: '',
    }
  }

  componentDidMount=() => {
    const { selectedTable, history } = this.props
    if (!selectedTable && window.location.pathname.includes('/table')) {
      history.push('/basket/change_table')
    }
  }

  componentDidUpdate = (prevProps) => {
    const { selectedTable } = this.props
    if (selectedTable && !window.location.pathname.includes('/table')) {
      this.props.updateSelectedTable(null)
    }
  }

  goToHome = () => {
    const { history } = this.props
    const path = '/home'
    history.push(path, { from: '/basket/change_table' })
  }

  goToTableDetail = async (table) => {
    const { history } = this.props
    history.push('/basket/change_table/table', { from: '/basket/change_table' })
    this.setState({ loadingTableOrders: true })
    await this.props.updateSelectedTable(table)
    this.setState({ loadingTableOrders: false })
  }

  handleChangeTable = (table) => {
    const { merchant, selectedTable, createBasket } = this.props
    createBasket({
      merchantId: merchant.id,
      table: table || selectedTable,
    })
  }

  renderTable (table) {
    const {
      classes,
      activeTables,
      basket,
    } = this.props
    const isLoading = !activeTables

    const isActive = _.includes(activeTables, table)
    const isCurrentTable = table === basket.table

    const swithIndicatorStyle = () => {
      if (isLoading) return classes.loadingIndicator
      if (isActive) return classes.activeTableIndicator
      return classes.inactiveTableIndicator
    }
    const switchChangeTableButtonStyle = () => {
      if (isLoading) return classes.disabledChangeTableButton
      return classes.enabledChangeTableButton
    }

    const indicatorStyle = swithIndicatorStyle()
    const changeTableButtonStyle = switchChangeTableButtonStyle()
    const tableStyle = isCurrentTable ? classes.currentTable : classes.table

    return (
      <div
        key={`${table}`}
        id={table}
        className={tableStyle}
        onClick={() => {
          if (isActive) {
            this.goToTableDetail(table)
          } else {
            // footer.handleChangeTable
            const { merchant, history, createBasket } = this.props
            createBasket({
              merchantId: merchant.id,
              table,
            })
            // footer.goToHome
            const path = '/home'
            history.push(path)
            console.info('route changed', path)
          }
        }}
      >
        <div className={classes.tableLeftContent} >
          <div className={indicatorStyle} />
          {table}
        </div>
        {/* <div
          className={changeTableButtonStyle}
          onClick={() => {
            if (!isCurrentTable) {
              this.handleChangeTable(table)
            }
            this.goToHome()
          }}>
          <FontAwesomeIcon icon='chevron-right' />
        </div> */}
      </div>
    )
  }

  renderTableGroups () {
    const {
      intl,
      merchant,
      classes,
      basket,
    } = this.props

    if (!merchant) return

    const {
      tables, // array of strings
      tableGroups, // object, array of strings
    } = merchant

    if (!_.isEmpty(tableGroups)) {
      // find tables not in tableGroups
      const tableMap = _.reduce(tables, (a, c, i) => {
        a[c] = true
        return a
      }, {})
      _.map(tableGroups, (group, key) => {
        _.map(group, table => {
          tableMap[table] = false
        })
      })
      const ungroupedTables = _(tableMap)
        .pickBy(v => v)
        .keys()
        .value()
      // create temp tableGroup
      if (ungroupedTables.length) {
        tableGroups[intl.formatMessage({ id: 'otherTableGroups' })] = ungroupedTables
      }

      return _.map(tableGroups, (group, key) => {
        return (
          <Collapse
            key={key}
            title={key}
            group={group}
            expand={this.state.expandGroup === '' ? group.includes(basket.table) : this.state.expandGroup === key}
            onClick={(value) => this.setState({ ...this.state, expandGroup: value })}
          >
            <div className={classes.tablesContainer}>
              {_.map(group, table => this.renderTable(table))}
            </div>
          </Collapse>
        )
      })
    } else {
      return (
        <div className={classes.tablesContainer}>
          {_.map(tables, table => this.renderTable(table))}
        </div>
      )
    }
  }

  organizeAllBatchesItems = (batches) => {
    const allItems = {}
    batches.forEach(batch => batch.items.forEach(item => {
      if (!allItems[item.menuId]) {
        allItems[item.menuId] = { name: item.name, count: 1 }
      } else {
        allItems[item.menuId] = { name: item.name, count: allItems[item.menuId].count += 1 }
      }
    }))
    return allItems
  }

  renderSelectedTableOrders = () => {
    const { intl, classes, activeTablesOrders, selectedTable } = this.props
    const selectedTableOrders = activeTablesOrders.filter(order => order.table === selectedTable)

    const _todayText = intl.formatMessage({ id: 'checkout.today' })
    const _serialText = intl.formatMessage({ id: 'checkout.serial' })
    const _inactiveTableText = intl.formatMessage({ id: 'changeTable.inactiveTable' })

    if (this.state.loadingTableOrders) {
      return (
        <div className={classes.inactiveTableCard}>
          {intl.formatMessage({ id: 'loading' })}
        </div>
      )
    }
    if (selectedTableOrders.length === 0) {
      return (
        <div className={classes.inactiveTableCard}>
          <div className={classes.inactiveTable}>{_inactiveTableText}</div>
        </div>
      )
    }

    return (
      _.map(selectedTableOrders, (order, index) => {
        const { batches } = order
        const { createdAt, status } = order
        const allBatchesItems = this.organizeAllBatchesItems(batches)
        const totalVariants = _.reduce(allBatchesItems, (accumulator, item) => accumulator + 1, 0)

        const _time = helpers.date.getTimeFormat(createdAt)
        const _isToday = helpers.date.isToday(createdAt)
        const _date = _isToday ? _todayText : helpers.date.getDateFormat(createdAt)
        const _status = intl.formatMessage({ id: 'checkout.status.' + status })
        const _totalOfFrontText = intl.formatMessage({ id: 'checkout.total_of_front' })
        const _totalOfBackText = intl.formatMessage({ id: 'checkout.total_of_back' })

        const orderTimeStyle = _isToday ? classes.todayOrderTime : classes.pastOrderTime

        return (
          <div key={index} className={classes.orderCard}>
            <div className={classes.orderHeader}>
              <div className={orderTimeStyle}>
                <span style={{ marginRight: 10 }}>{_date}</span>
                <span>{_time}</span>
              </div>
              <div className={classes.orderStatusBadge}>{_status}</div>
            </div>

            <div className={classes.orderDetail}>
              <div className={classes.orderSerial}>{`${_serialText}: ${order.serial}`}</div>
              <ul className={classes.orderItemsList}>
                {_.map(allBatchesItems, (item, key) => {
                  return <li key={key}>{`${item.name} x ${item.count}`}</li>
                })}
              </ul>
            </div>
            <div className={classes.orderVariants}>
              {`${_totalOfFrontText} ${totalVariants} ${_totalOfBackText}`}
            </div>
            <div className={classes.orderTotal}>
              <FontAwesomeIcon icon='dollar-sign' className={classes.dollarSign} />
              {order.total}
            </div>
          </div>
        )
      })
    )
  }

  renderTableDetail = () => {
    const { intl, classes, selectedTable } = this.props
    const _tableNoText = selectedTable ? intl.formatMessage({ id: 'footer.table_no' }, { value: selectedTable }) : ''

    return (
      <React.Fragment>
        <div className={classes.tableHeader}>{_tableNoText}</div>
        {this.renderSelectedTableOrders()}
      </React.Fragment>
    )
  }

  render () {
    const { selectedTable } = this.props
    return (
      <div>
        {selectedTable ? this.renderTableDetail() : this.renderTableGroups()}
      </div>
    )
  }
}

const styles = {
  tablesContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.5,
    margin: '0px',
    height: 'calc(100% - 2px)',
    width: 'calc(100%/3 - 7px)',
    minHeight: '120px',
    border: 'solid 1px #000',
    transition: 'background-color 150ms ease',
    paddingLeft: 5,
  },
  currentTable: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.5,
    margin: '0px',
    height: 'calc(100% - 2px)',
    width: 'calc(100%/3 - 7px)',
    minHeight: '120px',
    border: 'solid 1px #f19736',
    transition: 'background-color 150ms ease',
    paddingLeft: 5,
  },
  tableLeftContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: 35,
  },
  loadingIndicator: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    background: '#ccc',
    marginRight: 16,
    marginLeft: 8,
  },
  activeTableIndicator: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    background: '#F34E36',
    marginRight: 16,
    marginLeft: 8,
  },
  inactiveTableIndicator: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    background: '#30C453',
    marginRight: 16,
    marginLeft: 8,
  },
  inactiveTableBadge: {
    alignSelf: 'stretch',
    fontSize: 18,
    marginRight: 16,
    padding: 8,
    backgroundColor: '#fff',
    borderRadius: 8,
    color: '#f19736',
    border: '1px solid #f19736',
  },
  enabledChangeTableButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 16,
    width: 16,
    color: '#614D4A',
    border: '1px solid #614D4A',
    borderRadius: '50%',
    margin: 'auto 8px',
    cursor: 'pointer',
  },
  disabledChangeTableButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 16,
    width: 16,
    color: '#ccc',
    border: '1px solid #ccc',
    borderRadius: '50%',
    margin: 'auto 8px',
    cursor: 'pointer',
  },
  tableHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 16px',
    marginTop: 8,
    fontSize: 22,
    fontWeight: 'bold',
  },
  inactiveTableCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    borderRadius: 15,
    margin: '8px 16px',
    minHeight: 150,
    boxShadow: '0 4px 8px 0 #CBC8C2',
  },
  inactiveTable: {
    flex: 1,
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 8,
    color: '#f19736',
    border: '1px solid #f19736',
    borderRadius: 15,
  },
  orderCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    backgroundColor: '#fff',
    borderRadius: 15,
    margin: '8px 16px',
    minHeight: 150,
    boxShadow: '0 4px 8px 0 #CBC8C2',
  },
  orderHeader: {
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 8,
    marginBottom: 8,
    paddingTop: 8,
    paddingBottom: 8,
  },
  orderDetail: {
    alignSelf: 'stretch',
    paddingLeft: 16,
    paddingRight: 16,
  },
  todayOrderTime: {
    width: 130,
    color: '#fff',
    backgroundColor: '#a91d1d',
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    padding: '5px 24px',
    fontSize: 12,
  },
  pastOrderTime: {
    width: 130,
    color: '#fff',
    backgroundColor: '#d9cecc',
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    padding: '5px 24px',
    fontSize: 12,
  },
  orderStatusBadge: {
    fontSize: 12,
    marginRight: 16,
    padding: 4,
    backgroundColor: '#fff',
    borderRadius: 2,
    color: '#f19736',
    border: '1px solid #f19736',
  },
  orderSerial: {
    fontSize: 12,
  },
  orderItemsList: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: '#f5f5f5',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#f5f5f5',
    margin: '8px 0px',
    padding: '8px 0px',
    paddingLeft: 40,
  },
  orderVariants: {
    alignSelf: 'stretch',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'flex-end',
    fontSize: 14,
    color: '#A59996',
    paddingLeft: 16,
    paddingRight: 16,
  },
  orderTotal: {
    alignSelf: 'stretch',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'flex-end',
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 8,
    marginBottom: 8,
    fontSize: 22,
    fontWeight: 'bold',
  },
  dollarSign: {
    fontSize: 14,
    marginTop: 'auto',
    marginBottom: 'auto',
    marginRight: 2,
  },
}

const mapStateToProps = (state) => {
  return {
    basket: state.basket,
    merchant: state.merchant,
    activeTables: state.activeTables,
    activeTablesOrders: state.activeTablesOrders,
    selectedTable: state.selectedTable,
  }
}

const mapDispatchToProps = {
  getMerchant: merchantActions.getMerchant,
  getActiveTables: tableActions.getActiveTables,
  updateSelectedTable: tableActions.updateSelectedTable,
  createBasket: basketActions.createBasket,
}

export default withRouter(
  compose(
    connect(mapStateToProps, mapDispatchToProps),
    injectSheet(styles),
    injectIntl,
  )(TableList),
)



// WEBPACK FOOTER //
// ./src/components/TableList.jsx